import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod/v4-mini"

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            sourceImage: anyImageOpResult,
            blackLevel: z.union([anyImageOpResult, z.number()]),
            whiteLevel: z.union([anyImageOpResult, z.number()]),
            gamma: z._default(z.number(), 1),
        }),
    },
}
